import React, {FC, ReactNode} from 'react';
import clsx from 'clsx';

import style from './implement-method-grid.module.styl';

interface ImplementMethodGridProps {
  children: ReactNode;
  className?: string;
}
export const ImplementMethodGrid: FC<ImplementMethodGridProps> = ({children, className}) => {
  return (
    <div className={clsx(style.implementSection, className)}>
      <div className={style.implementGrid}>{children}</div>
    </div>
  );
};
